export default [
    {
        path: '/task',
        name: 'task',
        component: () => import('@/views/task/index.vue'),
        meta: {
            layout: 'full',
        },
    },
]